import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";

function CookieConsent() {
  const [cookies, setCookie] = useCookies(["cookieConsent"]);
  const [visible, setVisible] = useState(false);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    // show banner only if cookieConsent is not set
    if (!cookies.cookieConsent) {
      setVisible(true);
    }
  }, [cookies]);

  const handleAccept = () => {
    setCookie("cookieConsent", "accepted", { path: "/", maxAge: 31536000 }); // 1 year
    setVisible(false);
    setShowForm(true); // show form after accept
  };

  const handleReject = () => {
    setCookie("cookieConsent", "rejected", { path: "/", maxAge: 31536000 });
    setVisible(false);
  };

  if (visible) {
    return (
      <div style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "#222",
        color: "#fff",
        padding: "15px",
        textAlign: "center",
        zIndex: 1000,
      }}>
        <p>We use cookies to improve your experience. Do you accept?</p>
        <button
          onClick={handleAccept}
          style={{ marginRight: 10, padding: "8px 16px", background: "green", color: "#fff", border: "none", borderRadius: 5 }}
        >
          Accept
        </button>
        <button
          onClick={handleReject}
          style={{ padding: "8px 16px", background: "red", color: "#fff", border: "none", borderRadius: 5 }}
        >
          Reject
        </button>
      </div>
    );
  }

if (showForm) {
  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        zIndex: 2000,
        width: "400px",
        maxWidth: "90%",
      }}
    >
      {/* Close button */}
      <button
        onClick={() => setShowForm(false)}
        style={{
          position: "absolute",
          top: "10px",
          right: "15px",
          background: "transparent",
          border: "none",
          fontSize: "20px",
          fontWeight: "bold",
          cursor: "pointer",
          color: "#333",
        }}
      >
        ×
      </button>

      <h3 style={{ textAlign: "center", marginTop: "10px" }}>Enter Your Info</h3>
      <form
        action="https://formspree.io/f/mzzapong"
        method="POST"
        style={{ textAlign: "center" }}
      >
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          required
          style={{ display: "block", margin: "10px auto", padding: "8px", width: "80%" }}
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          required
          style={{ display: "block", margin: "10px auto", padding: "8px", width: "80%" }}
        />
        <button
          type="submit"
          style={{
            padding: "8px 16px",
            background: "blue",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            marginTop: "10px",
          }}
        >
          Submit
        </button>
      </form>
    </div>
  );
}


  return null;
}

export default CookieConsent;
